import { get } from 'lodash-es';
import moment from 'moment';

export const isDateAfter = (value1, value2) => {
  if (!value1 || !value2) return false;

  const date1 = moment(value1, 'YYYY-MM-DD');
  const date2 = moment(value2, 'YYYY-MM-DD');

  // eslint-disable-next-line no-restricted-globals
  return !isNaN(date1) && !isNaN(date2) && date1 >= date2;
};

export const isDateValid = (today, strings) => value => {
  if (isDateAfter(value, today)) {
    return { status: true };
  }

  return { status: false, message: get(strings, 'validation.field.invalid_date', 'Date non valide') };
};

export const isReleaseDateValid = (today, strings, formApi) => value => {
  if (isDateAfter(value, get(formApi.getState(), 'values.date', today))) {
    return { status: true };
  }

  return { status: false, message: get(strings, 'validation.field.invalid_date', 'Date non valide') };
};
